import type { ReactNode } from "react";
import clsx from "clsx";
import { DocumentDownloadButton } from "../document-download-button";
import { DocumentFileLink } from "../document-file-link";
import "./document-file-row.scss";

export type DocumentFileRowProps = {
  fileName: string;
  documentUrl?: string | null;
  fileId?: string | null;
  blobUrl?: string | null;
  localFile?: File | null;
  className?: string;
  linkClassName?: string;
  actions?: ReactNode;
  inline?: boolean;
  /** Позиция иконки скачивания относительно текста */
  downloadIconPosition?: "left" | "right";
  /** Внешний вид текста: link — синяя ссылка, plain — обычный текст */
  variant?: "link" | "plain";
  /** Отключить открытие по клику на название (вид ссылки сохраняется) */
  disableLinkAction?: boolean;
};

export function DocumentFileRow({
  fileName,
  documentUrl,
  fileId,
  blobUrl,
  localFile,
  className,
  linkClassName,
  actions,
  inline = false,
  downloadIconPosition = "left",
  variant = "link",
  disableLinkAction = false,
}: DocumentFileRowProps) {
  const downloadButton = (
    <DocumentDownloadButton
      fileName={fileName}
      documentUrl={documentUrl}
      fileId={fileId}
      blobUrl={blobUrl}
      localFile={localFile}
    />
  );

  const fileLink = (
    <DocumentFileLink
      className={linkClassName}
      fileName={fileName}
      documentUrl={documentUrl}
      fileId={fileId}
      blobUrl={blobUrl}
      localFile={localFile}
      variant={variant}
      disableLinkAction={disableLinkAction}
    />
  );

  return (
    <div
      className={clsx(
        "document-file-row",
        inline && "document-file-row--inline",
        downloadIconPosition === "right" && "document-file-row--download-right",
        className,
      )}
    >
      <div className="document-file-row__link-group">
        {downloadIconPosition === "left" ? (
          <>
            {downloadButton}
            {fileLink}
          </>
        ) : (
          <>
            {fileLink}
            {downloadButton}
          </>
        )}
      </div>
      {actions ? (
        <div className="document-file-row__actions">{actions}</div>
      ) : null}
    </div>
  );
}
